// some parts borrowed from airbnb/react-dates
// The MIT License (MIT)
// Copyright (c) 2016 Airbnb

import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"

import CalendarMonth from "../../components/calendar/CalendarMonth"
import getMonths from "../../components/calendar/getMonths"
import { browserIsMobile } from "../../redux/browserSelector"

function CalendarContainer({
  clickDay,
  closeAction,
  isMobile,
  isDisabled = () => false,
  isOnSale = () => false,
  selectedDays,
}) {
  const wrapperStyle = isMobile
    ? { marginLeft: "auto", marginRight: "auto" }
    : {
        marginLeft: "auto",
        marginRight: "auto",
        display: "grid",
        gridGap: "20px",
        gridTemplateColumns: "repeat(2, calc(50% - 10px))",
      }
  const calendarStyle = isMobile ? { marginBottom: "20px" } : {}

  return (
    <div
      style={{
        overflowY: "scroll",
        marginLeft: isMobile ? "-10px" : 0,
        marginRight: isMobile ? "-20px" : "-10px",
        maxHeight: isMobile ? "calc(100vh - 130px)" : "calc(100vh - 250px)",
      }}
    >
      <div style={{ display: "flex" }}>
        <div style={{ flex: 1, textAlign: "center" }}>
          <div style={wrapperStyle}>
            {getMonths().map((month) => (
              <CalendarMonth
                style={calendarStyle}
                isDisabled={isDisabled}
                isOnSale={isOnSale}
                key={`calmonth${month.format()}`}
                month={month}
                clickDay={(day) => {
                  closeAction()
                  clickDay(day)
                }}
                selectedDays={selectedDays}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

CalendarContainer.propTypes = {
  clickDay: PropTypes.func.isRequired,
  closeAction: PropTypes.func.isRequired,
  selectedDays: PropTypes.array.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isDisabled: PropTypes.func,
  isOnSale: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    isMobile: browserIsMobile(state),
  }
}

export default connect(mapStateToProps)(CalendarContainer)
